import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getBreaks } from "@/Services/TherapyApi/Clients";
import BreakTransformer from "@/Modules/Transformers/Patients/Break";

import usePatientsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

import { hasValue } from "@/Utils/Objects";

async function fetchBreaksActionHandler(patientUuid: string): Promise<boolean> {
  const patientsStore = usePatientsStore();
  const appStore = useAppStore();

  patientsStore.isLoading = true;

  try {
    const breaks = await getBreaks(patientUuid);

    if (hasValue(patientsStore.selected)) {
      patientsStore.selected.breaks = {
        previous: breaks.previous.map(BreakTransformer.toDomain),
        current: breaks.current.map(BreakTransformer.toDomain),
      };
    }

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    patientsStore.isLoading = false;
  }
}

export default fetchBreaksActionHandler;
